import React from 'react';
import { UNDERWRITING_CONFIG } from './config/underwritingFeedbackConfig';

/**
 * Trigger Box Component
 * 
 * Displays individual trigger/metric value in a rounded box
 * Color-coded based on risk level
 */
const TriggerBox = ({ label, value, nullable = false }) => {
  const { styling, riskColors } = UNDERWRITING_CONFIG;

  // Handle null values for nullable triggers
  const displayValue = value === null || value === undefined 
    ? (nullable ? 'None' : '-')
    : value;

  // Get color based on risk level
  const valueColor = riskColors[value] || '#000';

  return (
    <div 
      className="trigger-box"
      style={{ 
        borderRadius: styling.triggerBoxRadius,
        padding: styling.triggerBoxPadding
      }}
    >
      <div className="trigger-label">{label}</div>
      <div 
        className="trigger-value"
        style={{ color: valueColor }}
      >
        {displayValue}
      </div>
    </div>
  );
};

export default TriggerBox;
